module.exports = __webpack_public_path__ + "static/media/je.6aeb44cc.svg";